

/* eslint-disable react/no-unused-state */

/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { VideoPopup as SourceVideoPopup } from 'SourceComponent/VideoPopup/VideoPopup.component';
// import { VIMEO_FORMAT } from 'SourceComponent/VideoPopup/VideoPopup.config';
import { YOUTUBE_FORMAT, YOUTUBE_SHARE_FORMAT, VIMEO_FORMAT } from './VideoPopup.config';

import './VideoPopup.style';

/**
 * A popup capable of displaying a video
 * @class VideoPopup
 * @namespace Component/VideoPopup/Component
 */
export class VideoPopup extends SourceVideoPopup {

    /**
     * Parses the video URL and renders the video accordingly
     * @returns {null|*}
     * @private
     */
    _renderVideoContent() {
        const {
            payload: {
                media: {
                    video_content: { video_url } = {}
                } = {}
            }
        } = this.props;

        if (!video_url) {
            return null;
        }

        const [, vimeoId] = VIMEO_FORMAT.exec(video_url) || [];
        if (vimeoId) {
            return this._renderVimeoVideo(vimeoId);
        }

        const [, youtubeShareId] = YOUTUBE_SHARE_FORMAT.exec(video_url) || [];
        if (youtubeShareId) {
            return this._renderYoutubeVideo(youtubeShareId);
        }
        // const testId = video_url.split("?v=")[1].split("&")[0]
        // This does skips IDs with the '-' inside and since the videourl skips embeded and timestamps a simple split should workk fine 
        const [, youtubeId] = YOUTUBE_FORMAT.exec(video_url) || [];
        if (youtubeId) {
            return this._renderYoutubeVideo(youtubeId);
        }

        return null;
    }
}

export default VideoPopup;
